import axios from 'axios';

const API_URL = 'https://api.paragaia.tn/category';

export const getAllCategories = () => {
  return axios.get(API_URL);
};

export const getCategoryById = (id) => {
  return axios.get(`${API_URL}/${id}`);
};

